const $ripple = $(".js-ripple");

/**
 * Add ripple animation
 */
const addRippleEffect = () => {
    $ripple.on("click.ui.ripple", (e) => {
        const $this = $(e.target);
        const $offset = $this.parent().offset();
        const $circle = $this.find(".ripple-circle");
        const x = e.pageX - $offset.left;
        const y = e.pageY - $offset.top;
        const $caseofInput = $this.siblings(".caseof-input");

        $circle.css({
            top: y + "px",
            left: x + "px"
        });

        $this.addClass("is-active");

        if ($caseofInput.length) {
            $caseofInput.trigger("click");
        }
    });
};

/**
 * Remove ripple animation
 */
const removeRippleEffect = () => {
    $ripple.on("animationend webkitAnimationEnd oanimationend MSAnimationEnd", () => {
        $ripple.removeClass("is-active");
    });
};

addRippleEffect();
removeRippleEffect();
